import React from 'react';
import styles from './LoadingST.module.scss';
import { withBasePath } from '@src/common/path-convert';
import { useTranslation } from 'next-i18next';
import { observer } from 'mobx-react-lite';
import { useStores } from '@src/pages/_app';

export const LoadingST = () => {
    const { t } = useTranslation('common');
    const { loadingStore } = useStores();

    return loadingStore.loading ? (
        <div className={styles.loadingBG}>
            <div className={styles.loadingST}>
                <img src={withBasePath('/images/loading.png')} alt='' loading='lazy' />
                <div className='loadingText'> {t('loading')}</div>
            </div>
        </div>
    ) : null;
};

export default observer(LoadingST);
